import type { Location } from '@/api/v4/locations.api';
import { useFetchLocationsCached } from '@/hooks/queries/use-locations.query';

export const useLocationOptions = () => {
  const fetchLocationsCached = useFetchLocationsCached();

  const setOptions = async (search: string) => {
    const results = await fetchLocationsCached({
      page: 1,
      search,
      type: ['continent', 'country'],
    });

    return results.map((location: Location) => ({
      label: location.shortDescription,
      value: JSON.stringify({
        id: location.id,
        type: location.type,
      }),
    }));
  };

  return { setOptions };
};
